import { gql } from '@apollo/client';

export const getAgendaUser = gql/* GraphQL */ `
query GetAgendaUser($userId: ID!) {
    getAgendaUser(userId: $userId) {
      comId
      image
      isConfirmed
      role
      suspended
      type
      FCMtoken
      userId
      username
      readedAt
      __typename
    }
  }
  `;

export const shiftAppsByComId = gql/* GraphQL */ `query ShiftAppsByComId(
  $comId: ID!
  $filter: ModelAgendaShiftApplicationFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
) {
  shiftAppsByComId(
    comId: $comId
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
      user {
        image
      }
    }
    nextToken
    __typename
  }
}
`;

export const shiftAppsByLoc = gql/* GraphQL */ `query ShiftAppsByLoc(
  $filter: ModelAgendaShiftApplicationFilterInput
  $limit: Int
  $location: String!
  $nextToken: String
  $sortDirection: ModelSortDirection
  $startAt: ModelStringKeyConditionInput
) {
  shiftAppsByLoc(
    filter: $filter
    limit: $limit
    location: $location
    nextToken: $nextToken
    sortDirection: $sortDirection
    startAt: $startAt
  ) {
    items {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      lat
      lng
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const updateAgendaShiftApplication = gql/* GraphQL */ `mutation UpdateAgendaShiftApplication(
  $condition: ModelAgendaShiftApplicationConditionInput
  $input: UpdateAgendaShiftApplicationInput!
) {
  updateAgendaShiftApplication(condition: $condition, input: $input) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    info
    location
    role
    shiftAppId
    shifts {
      nextToken
      __typename
    }
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

export const createAgendaShiftApplicationByUserId = gql/* GraphQL */ `mutation CreateAgendaShiftApplicationByUserId(
  $accepted: Boolean
  $comId: ID
  $confirmed: Boolean
  $createdAt: AWSDateTime
  $deleted: Boolean
  $info: String
  $location: String
  $role: String
  $shiftAppId: ID!
  $startAt: AWSDateTime
  $stopAt: AWSDateTime
  $suspended: Boolean
  $updatedAt: AWSDateTime
  $userId: ID
  $username: String
  $lat: String
  $lng: String
) {
  createAgendaShiftApplicationByUserId(
    accepted: $accepted
    comId: $comId
    confirmed: $confirmed
    createdAt: $createdAt
    deleted: $deleted
    info: $info
    location: $location
    role: $role
    shiftAppId: $shiftAppId
    startAt: $startAt
    stopAt: $stopAt
    suspended: $suspended
    updatedAt: $updatedAt
    userId: $userId
    username: $username
    lat: $lat
    lng: $lng
  ) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    info
    location
    role
    shiftAppId
    shifts {
      nextToken
      __typename
    }
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;

  export const usersByComId = gql/* GraphQL */ `
  query UsersByComId(
    $comId: ID!
    $filter: ModelAgendaUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    usersByComId(
      comId: $comId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        FCMtoken
        comId
        createdAt
        email
        firstName
        image
        isConfirmed
        language
        lastName
        password
        phoneNumber
        profileOwner
        readedAt
        role
        suspended
        type
        updatedAt
        userId
        username
        __typename
      }
      nextToken
      __typename
    }
  }
  `;

  export const createAgendaShiftByUserId = gql/* GraphQL */ `mutation CreateAgendaShiftByUserId(
  $accepted: Boolean
  $comId: ID
  $confirmed: Boolean
  $createdAt: AWSDateTime
  $deleted: Boolean
  $info: String
  $location: String
  $performance: String
  $punctuality: String
  $quality: String
  $rate: String
  $role: String
  $shiftAppId: ID
  $shiftId: ID!
  $startAt: AWSDateTime
  $stopAt: AWSDateTime
  $suspended: Boolean
  $updatedAt: AWSDateTime
  $userId: ID
  $username: String
  $lat: String
  $lng: String
) {
  createAgendaShiftByUserId(
    accepted: $accepted
    comId: $comId
    confirmed: $confirmed
    createdAt: $createdAt
    deleted: $deleted
    info: $info
    location: $location
    performance: $performance
    punctuality: $punctuality
    quality: $quality
    rate: $rate
    role: $role
    shiftAppId: $shiftAppId
    shiftId: $shiftId
    startAt: $startAt
    stopAt: $stopAt
    suspended: $suspended
    updatedAt: $updatedAt
    userId: $userId
    username: $username
    lat: $lat
    lng: $lng
  ) {
    accepted
    comId
    confirmed
    createdAt
    deleted
    honors {
      nextToken
      __typename
    }
    info
    location
    performance
    punch {
      nextToken
      __typename
    }
    punctuality
    quality
    rate
    requests {
      nextToken
      __typename
    }
    role
    shiftApp {
      accepted
      comId
      confirmed
      createdAt
      deleted
      info
      location
      role
      shiftAppId
      startAt
      stopAt
      suspended
      updatedAt
      userId
      username
      lat
      lng
      __typename
    }
    shiftAppId
    shiftId
    startAt
    stopAt
    suspended
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    lat
    lng
    __typename
  }
}
`;